import { useEffect, useState } from "react";

export const useDate = (inputDate?: string | Date) => {
    const [date, setDate] = useState<Date>(new Date());

    useEffect(() => {
        const date: Date = inputDate ? new Date(inputDate) : new Date();
        date.setHours(0, 0, 0, 0);

        setDate(date);
    }, [inputDate]);

    return { date, setDate };
};
